import { render, staticRenderFns } from "./subjectTypeUser.vue?vue&type=template&id=133d7c5d&scoped=true&"
import script from "./subjectTypeUser.vue?vue&type=script&lang=js&"
export * from "./subjectTypeUser.vue?vue&type=script&lang=js&"
import style0 from "./subjectTypeUser.vue?vue&type=style&index=0&id=133d7c5d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d7c5d",
  null
  
)

export default component.exports